'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = scrollToTop;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Higher-order component for scrolling to top upon mount.
 */
function scrollToTop(Target) {
  return function (_React$Component) {
    (0, _inherits3.default)(ScrollToTop, _React$Component);

    function ScrollToTop() {
      (0, _classCallCheck3.default)(this, ScrollToTop);
      return (0, _possibleConstructorReturn3.default)(this, (ScrollToTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollToTop)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollToTop, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        window.scrollTo(0, 0);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Target, this.props);
      }
    }]);
    return ScrollToTop;
  }(_react2.default.Component);
}
//# sourceMappingURL=scrollToTop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/decorators/scrollToTop.js
// module id = 88
// module chunks = 0